import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { portalApi, apiError } from "../lib/api";
import { usePortalAuth } from "../context/PortalAuth";
import { Sparkles } from "lucide-react";

export default function PortalVerify() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const { setSession } = usePortalAuth();
  const [error, setError] = useState("");

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setError("Kein Token gefunden."); return; }
    portalApi.post("/portal/auth/verify", { token })
      .then((r) => { setSession(r.data); nav("/portal/home"); })
      .catch((e) => setError(apiError(e)));
  }, [params, nav, setSession]);

  return (
    <div className="min-h-screen bg-[#4A1D24] flex items-center justify-center px-5 text-center">
      <div data-testid="portal-verify-screen">
        <Sparkles className="h-6 w-6 text-[#C59B6C] mx-auto animate-pulse" />
        {!error ? (
          <p className="text-stone-100 mt-4">Sie werden angemeldet…</p>
        ) : (
          <div className="text-stone-100">
            <p className="mt-4">{error}</p>
            <button onClick={() => nav("/portal")} className="mt-4 underline text-[#E7C79A]">Zur Anmeldung</button>
          </div>
        )}
      </div>
    </div>
  );
}
